require('build/babelHelpers');
require('utils/Url');

//Polyfills
require('whatwg-fetch');
require('core-js/fn/object/assign');
require('core-js/fn/promise');
require('core-js/fn/symbol');
require('performance-polyfill');
require('utils/shims/ObjectValues');

require('utils/framework/main').runApplication();
